import script from "./ResearchGroupManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResearchGroupManage.vue?vue&type=script&lang=ts&setup=true"

import "./ResearchGroupManage.vue?vue&type=style&index=0&id=03000d5d&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03000d5d"]])

export default __exports__